import {
  GROWTH_CASE_STUDY,
  GROWTH_CTA,
  GROWTH_DELIVERY,
  GROWTH_HERO,
  GROWTH_PROBLEMS,
  GROWTH_SEO,
  GROWTH_SERVICES,
  GROWTH_SERVICES_SECTION,
  GROWTH_WHAT_WHO,
} from '@/data/growth';
import { SITE_ORIGIN, useSeo } from '@/lib/seo';
import { ServiceLineHero } from '@/components/site/service/ServiceLineHero';
import { ServiceWhatWho } from '@/components/site/service/ServiceWhatWho';
import { ServiceProblems } from '@/components/site/service/ServiceProblems';
import { ServicePackages } from '@/components/site/service/ServicePackages';
import { ServiceDelivery } from '@/components/site/service/ServiceDelivery';
import { ServiceCaseStudy } from '@/components/site/service/ServiceCaseStudy';
import { CtaBand } from '@/components/site/CtaBand';

const ACCENT = '#029E88';
const ACCENT_DARK = '#01755F';
const ACCENT_SOFT = '#CCF2EC';

export default function GrowthPage() {
  const origin = SITE_ORIGIN;

  useSeo({
    title: GROWTH_SEO.title,
    description: GROWTH_SEO.description,
    canonical: `${origin}/services/growth`,
    ogImage: `${origin}/assets/amden-logo-dark.png`,
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'Amden Growth',
      provider: { '@type': 'Organization', name: 'Amden Group' },
      serviceType: 'Marketing strategy, social media and website support',
      areaServed: ['Ireland', 'United Kingdom'],
      description: GROWTH_SEO.description,
      url: `${origin}/services/growth`,
    },
  });

  return (
    <>
      <ServiceLineHero
        content={GROWTH_HERO}
        accent={ACCENT}
        accentDark={ACCENT_DARK}
        accentSoft={ACCENT_SOFT}
        testidPrefix="growth"
      />
      <ServiceWhatWho
        data={GROWTH_WHAT_WHO}
        accent={ACCENT}
        accentDark={ACCENT_DARK}
        accentSoft={ACCENT_SOFT}
        testidPrefix="growth"
      />
      <ServiceProblems
        data={GROWTH_PROBLEMS}
        accent={ACCENT}
        accentDark={ACCENT_DARK}
        accentSoft={ACCENT_SOFT}
        index="02"
        discussHref="/?service=growth#solution-finder"
        testidPrefix="growth"
      />
      <ServicePackages
        services={GROWTH_SERVICES}
        section={GROWTH_SERVICES_SECTION}
        accent={ACCENT}
        accentDark={ACCENT_DARK}
        accentSoft={ACCENT_SOFT}
        discussHref="/?service=growth#solution-finder"
        id="growth-services"
        testidPrefix="growth"
        layout="balanced3"
        topAccentBar
      />
      <ServiceDelivery
        data={GROWTH_DELIVERY}
        accent={ACCENT}
        index="04"
        testidPrefix="growth"
        sectionClass="bg-white"
      />
      <ServiceCaseStudy
        data={GROWTH_CASE_STUDY}
        accent={ACCENT}
        accentDark={ACCENT_DARK}
        index="05"
        testidPrefix="growth"
      />
      <CtaBand
        index={GROWTH_CTA.index}
        eyebrow={GROWTH_CTA.eyebrow}
        heading={GROWTH_CTA.heading}
        copy={GROWTH_CTA.copy}
        primaryLabel={GROWTH_CTA.primaryLabel}
        primaryHref={GROWTH_CTA.primaryHref}
        secondaryLabel={GROWTH_CTA.secondaryLabel}
        secondaryHref={GROWTH_CTA.secondaryHref}
      />
    </>
  );
}
